/** This file is auto generated by convertSvgToJsx.ts */

import React from 'react'
const play_medium = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M2 3.037v17.925c0 1.128 1.277 1.891 2.286 1.355l16.895-8.962c1.045-.555 1.073-2.14 0-2.71L4.286 1.683C3.3 1.158 2 1.885 2 3.037Z"
    />
  </svg>
)
export default play_medium
